import { EnumButtonName } from '@calm/evexia-analytics';
import { Close } from '@mui/icons-material';
import commonMessages from '@rhg/lang/messages/common';
import playerMessages from '@rhg/lang/messages/player';
import { Box, IconButton, Slide, Stack, Theme } from '@rhg/libs/material';
import { ChevronDown } from '@rhg/libs/material/icons';
import { responsivePaddingDefault, sxAppend } from '@rhg/libs/material/sx';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

const styleContainer = {
    width: '100%',
    zIndex: (theme: Theme) => theme.zIndex.audioPlayerUpperActions,
    position: 'absolute',
    top: 0,
    left: 0,
};

const styleStack = {
    p: responsivePaddingDefault,
};

const styleSideSlot = {
    flexShrink: 0,
    display: 'flex',
};

const styleSideSlotStart = sxAppend(styleSideSlot, {
    justifyContent: 'flex-start',
});

const styleSideSlotEnd = sxAppend(styleSideSlot, {
    justifyContent: 'flex-end',
});

const styleCenterSlot = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    minWidth: 0,
};

export interface AudioPlayerDialogUpperActionsProps {
    isShown: boolean;
    isMinimizeButtonDisplayed: boolean;
    isCloseButtonDisplayed: boolean;
    centerAction?: ReactNode;
    onMinimize?: () => void;
    onClose: () => void;
}

export function AudioPlayerDialogUpperActions({
    isShown,
    isMinimizeButtonDisplayed,
    isCloseButtonDisplayed,
    centerAction,
    onMinimize,
    onClose,
}: AudioPlayerDialogUpperActionsProps) {
    const { formatMessage } = useIntl();

    if (
        !isMinimizeButtonDisplayed &&
        !isCloseButtonDisplayed &&
        !centerAction
    ) {
        return null;
    }

    return (
        <Slide direction="down" in={isShown} mountOnEnter unmountOnExit>
            <Box sx={styleContainer}>
                <Stack
                    sx={styleStack}
                    direction="row"
                    alignItems="center"
                    gap={2}
                >
                    <Box sx={styleSideSlotStart}>
                        {isMinimizeButtonDisplayed && (
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={formatMessage(
                                    playerMessages['player.minimize']
                                )}
                                onClick={onMinimize}
                                size="medium"
                                trackButton={EnumButtonName.MinimizePlayer}
                            >
                                <ChevronDown />
                            </IconButton>
                        )}
                    </Box>
                    <Box sx={styleCenterSlot}>{centerAction}</Box>
                    <Box sx={styleSideSlotEnd}>
                        {isCloseButtonDisplayed && (
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={formatMessage(
                                    commonMessages['common.dismiss_dialog']
                                )}
                                onClick={onClose}
                                size="medium"
                                trackButton={EnumButtonName.Dismiss}
                            >
                                <Close />
                            </IconButton>
                        )}
                    </Box>
                </Stack>
            </Box>
        </Slide>
    );
}
